import { EllipsesLoader } from '@/app/common/components/EllipsesLoader'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import { useStudentPurses } from '@/app/pages/providers/api/usePaymentProviders'
import { PaymentDetail } from '@/schemas/payments.schema'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useSelector } from 'react-redux'
import { ReviewPaymentUI } from './ReviewPaymentUI'

type ReviewPaymentContainerProps = {
  payment: PaymentDetail
}

export type PaymentMutationDecision = 'accepted' | 'rejected'

export function ReviewPaymentContainer({
  payment,
}: ReviewPaymentContainerProps) {
  const programId = useSelector(selectProgramID)
  const application = useSelector(selectFamilyApplication)

  const pursesQuery = useStudentPurses({
    application_id: application.application_id,
    program_id: programId,
  })

  // Remove this TS warning for now since we probably will change where this information comes from.
  // @ts-ignore

  return (
    <div className="flex justify-between items-center w-full flex-wrap">
      <MultiQueryPageLoader
        customLoader={<EllipsesLoader size="lg" color="primary" />}
        queries={[pursesQuery] as const}
      >
        {([pursesData]) => (
          <ReviewPaymentUI payment={payment} pursesData={pursesData} />
        )}
      </MultiQueryPageLoader>
    </div>
  )
}
